module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_0.a10bc0f9.png";